import { withInstall } from '@lit-element/utils'

import Popconfirm from './src/popconfirm.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtPopconfirm: SFCWithInstall<typeof Popconfirm> =
  withInstall(Popconfirm)
export default LtPopconfirm

export * from './src/popconfirm'
